module.exports = __webpack_public_path__ + "static/img/team_group.af730ad.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/team_group.png
// module id = Q4UC
// module chunks = 1